/**
 * <BilanCard> — the "Bilan de la session" block (molecule, L0.1).
 *
 * A card titled "Bilan de la session" over a `<BulletList>` of the present commented-report lines
 * (strengths / challenges / progress / next goal). Renders nothing when no line is present.
 * Composes DS atoms/molecules only — `<Card>`, `<Title>`, `<BulletList>`.
 */
import React from "react"

import { Card } from "../Card"
import { Stack } from "../../atoms/containers/Stack"
import { Title } from "../../atoms/typography/Title"
import { BulletList } from "../BulletList"

export type BilanCardProps = {
    comments: {
        strengths?: string
        challenges?: string
        progress?: string
        nextGoal?: string
    }
    testID?: string
}

export function BilanCard(props: BilanCardProps) {
    const { comments, testID } = props
    const items = [comments.strengths, comments.challenges, comments.progress, comments.nextGoal].filter(
        (v): v is string => v != null && v !== ""
    )

    if (items.length === 0) return null

    return (
        <Card testID={testID} p="5">
            <Stack gap="4">
                <Title center uppercase size="text-xl">
                    Bilan de la session
                </Title>
                <BulletList items={items} />
            </Stack>
        </Card>
    )
}
